import { createActions, createReducer } from "reduxsauce";
import { arrayMove } from "react-sortable-hoc";
import notify from 'utils/modern_notify';

export const { Types, Creators } = createActions({
    buscarRemetentes: ["payload"],
    buscarRemetentesSucesso: ["payload"],
    mostrarMensagem: ["payload"],
    esconderMensagem: ["payload"],
    buscarRomaneios: ["payload"],
    buscarRomaneiosSucesso: ["payload"],
    buscarBases: ["payload"],
    buscarBasesSucesso: ["payload"],
    buscarMotoristas: ["payload"],
    buscarMotoristasSucesso: ["payload"],
    deletarRomaneios: ["payload"],
    deletarRomaneiosSucesso: ["payload"],
    buscarNotas: ["payload"],
    buscarNotasSemBanco: ["payload"],
    atualizarNotasRequestBanco: ["payload"],
    buscarNotasSucesso: ["payload"],
    buscarNotasEditar: ["payload"],
    buscarNotasEditarSucesso: ["payload"],
    incluirNotas: ["payload"],
    incluirNotasSucesso: ["payload"],
    criarRomaneios: ["payload"],
    criarRomaneiosSucesso: ["payload"],
    romaneioCriado: ["payload"],
    setNotaEdicao: ["payload"],
    setNotaEdicaoRomaneio: ["payload"],
    setNotaBusca: ["payload"],
    setNotaBuscaEdicao: ["payload"],
    resetRomaneio: ["payload"],
    deletarNotaSucesso: ["payload"],
    deletarNotaRomaneioSucesso: ["payload"],
    editarRomaneios: ["payload"],
    gerarRomaneios: ["payload"],
    gerarRomaneiosSucesso: ["payload"],
    setLoadGerarRomaneios: ["payload"],
    criarRomaneiosSemVerificar: ["payload"],
    atualizarRomaneios: ["payload"],
    atualizarRomaneiosSucesso: ["payload"],
    IncluirNotasRomaneio: ["payload"],
    notasExcluidaRomaneio: ["payload"],
    setAtuNotasRom: ["payload"],
    buscaRomValidar: ["payload"],
    buscaRomValidarSucesso: ["payload"],
    setRomSelecionado: ["payload"],
    resetRomaneioSelec: ["payload"],
    ListaNotasRomValidar: ["payload"],
    validarRomApp: ["payload"],
    validarRomAppSucesso: ["payload"],
    setMostrarRomaneiosValidados: ["payload"],
    setMostrarRomaneiosPdf: ["payload"],
    resetListBusRom: ["payload"],
    setDoc: ["payload"],
    OrdArrayNtBusca: ["payload"],
    OrdArrayNtBuscaSucesso: ["payload"],
    OrdArrayNtBuscaManual: ["payload"],
    notasOrdBanco: ["payload"],
    setTipoPdf: ["payload"],
    basesEmpresa: ["payload"],
    basesEmpresaSucesso: ["payload"],
    setLoad: ["payload"],
    setRomaneioEmEdicao: ["payload"],
    setFiltrosExport: ["payload"],
    setCriandoRomaneio: ["payload"],
    limparRomaneios: ["payload"],
    replaceRomaneio: ["payload"],
    mudaTotalNotas: ["payload"],
    mudaTotal: ["payload"],
    reseTotalNotas: ["payload"],
});

const INITIAL_STATE = {
    valoresIniciais: { motoristas: "", numeroPlaca: "", bases: "" },
    mensagemGeral: "",
    exibirMensagem: false,
    mostrarRomaneioCriado: false,
    mostrarRomaneioAtualizado: false,
    mostrarEditarRomaneio: false,
    abrirEditar: false,
    romaneiosBusca: [],
    basesRomenios: [],
    romDeletados: [],
    motoristasRomaneios: [],
    notasBusca: [],
    notasIncluir: [],
    listaNotasRomaneios: [],
    romaneiosCriar: { notas: [], romaneio: {} },
    notaEdicao: {},
    NotaEdicaoRomaneio: {},
    notasEdicaoRomaneio: {},
    romaneiosGerados: [],
    romaneiosGeradosSelecionados: 0,
    orderRomaneios: "asc",
    orderByRomaneios: "romaneio",
    qtdBipe: 0,
    valorB: 0.0,
    valorProdutoB: 0.0,
    volumeB: 0.0,
    freteB: 0.0,
    paginaRomaneios: 0,
    linhasPorPaginaRomaneios: 25,
    romaneiosMensagem: "",
    showMessageRomaneios: false,
    loadGerarRomaneios: false,
    romaneioEdicao: {},
    notasRomaneioCriado: [],
    notasRomaneioEditar: [],
    notasExcluidas: [],
    romaneioAtualizado: [],
    notasRomaneioAtualizado: [],
    romaneiosValidacao: [],
    romaneiosSelecionados: [],
    romaneiosSelecionadosNotas: [],
    romaneiosAprovApp: [],
    mostrarRomaneiosValidados: false,
    notasEdicaoRomaneioNotas: [],
    notasEdicaoRomaneioPdf: [],
    mostrarRomaneiosPdf: false,
    ordManual: [],
    ordBanco: [],
    arOrdemBd: [],
    agrupaDist: [],
    tpPdf: "",
    basesRom: [],
    load: false,
    criandoRomaneio: false,
    romaneioEmEdicao: {},
    doc: { label: "NOTA", value: "NOTA" },
};

const setLoad = (state = INITIAL_STATE, action) => ({
    ...state,
    load: action.payload,
});

const setDoc = (state = INITIAL_STATE, action) => ({
    ...state,
    doc: action.payload,
});

const notasOrdBanco = (state = INITIAL_STATE, action) => ({
    ...state,
    ordBanco: action.payload,
});

const setTipoPdf = (state = INITIAL_STATE, action) => ({
    ...state,
    tpPdf: action.payload,
});

const OrdArrayNtBuscaSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        arOrdemBd: action.payload,
    };
};

const OrdArrayNtBuscaManual = (state = INITIAL_STATE, action) => ({
    ...state,
    ordManual: action.payload,
});

const notasExcluidaRomaneio = (state = INITIAL_STATE, action) => {
    let notasExcluidas = state.notasExcluidas.slice();
    notasExcluidas.push(action.payload);

    return {
        ...state,
        notasExcluidas,
    };
};

const setRomSelecionado = (state = INITIAL_STATE, action) => ({
    ...state,
    romaneiosSelecionados: action.payload,
});

const ListaNotasRomValidar = (state = INITIAL_STATE, action) => ({
    ...state,
    romaneiosSelecionadosNotas: action.payload,
});

const acaoMostarMensagem = (state = INITIAL_STATE, action) => ({
    ...state,
    mensagemGeral: action.payload,
    exibirMensagem: true,
});

const esconderMensagem = (state = INITIAL_STATE, action) => ({
    ...state,
    exibirMensagem: false,
});

const setMostrarRomaneiosValidados = (state = INITIAL_STATE, action) => ({
    ...state,
    mostrarRomaneiosValidados: action.payload,
});

const setMostrarRomaneiosPdf = (state = INITIAL_STATE, action) => ({
    ...state,
    mostrarRomaneiosPdf: action.payload,
});

const buscarRomaneiosSucesso = (state = INITIAL_STATE, action) => ({
    ...state,
    romaneiosBusca: action.payload,
    load: false,
});

const buscarRomaneios = (state = INITIAL_STATE, action) => ({
    ...state,
    romaneiosBusca: [],
});

const validarRomAppSucesso = (state = INITIAL_STATE, action) => {
    const { numerosRom, romaneiosValidado } = action.payload;

    let novoRomVali = state.romaneiosValidacao;

    if (romaneiosValidado.naoAtualizados > 0) {
        romaneiosValidado.romaneiosNaoAtualizados.forEach((element) => {
            novoRomVali = novoRomVali.filter(
                (rom) => rom.numero_romaneio !== element.numero_romaneio
            );
        });
    } else {
        numerosRom.forEach((element, key) => {
            novoRomVali = novoRomVali.filter(
                (rom) => rom.numero_romaneio !== element
            );
        });
    }
    const romaneiosAprovApp = romaneiosValidado.romaneiosAtualizados
        ? romaneiosValidado.romaneiosAtualizados
        : [];
    return {
        ...state,
        romaneiosAprovApp,
        mostrarRomaneiosValidados: true,
        romaneiosValidacao: novoRomVali,
    };
};

const buscarBasesSucesso = (state = INITIAL_STATE, action) => ({
    ...state,
    basesRomenios: action.payload,
});

const buscaRomValidarSucesso = (state = INITIAL_STATE, action) => ({
    ...state,
    romaneiosValidacao: action.payload,
});

const mudaTotalNotas = (state = INITIAL_STATE, action) => {
    const { index, volume, valor, valor_prod, frete } = action.payload;

    return {
        ...state,
        qtdBipe: state.qtdBipe + index,
        valorB: state.valorB + valor,
        valorProdutoB: state.valorProdutoB + valor_prod,
        volumeB: state.volumeB + volume,
        freteB: state.freteB + frete,
    };
};

const mudaTotal = (state = INITIAL_STATE, action) => {
    const { volume, valor, valor_prod, frete, index } = action.payload;

    return {
        ...state,
        qtdBipe: index ? index : state.qtdBipe,
        valorB: valor,
        valorProdutoB: valor_prod,
        volumeB: volume,
        freteB: frete,
    };
};

const reseTotalNotas = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        qtdBipe: 0,
        valorB: 0,
        volumeB: 0,
        freteB: 0,
    };
};

const deletarRomaneiosSucesso = (state = INITIAL_STATE, action) => {
    const { romaneiosBusca } = state;

    const { index } = action.payload;

    const newList = romaneiosBusca.filter((nota, i) => i !== index);

    return {
        ...state,
        romaneiosBusca: newList,
    };
};

const buscarMotoristasSucesso = (state = INITIAL_STATE, action) => ({
    ...state,
    motoristasRomaneios: action.payload,
});

const incluirNotasSucesso = (state = INITIAL_STATE, action) => ({
    ...state,
    notasIncluir: action.payload,
});

const buscarNotasSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        notasBusca: action.payload,
    };
};

const atualizarNotasRequestBanco = (state = INITIAL_STATE, action) => {
    const { payload } = action;
    let notasBusca = state.notasBusca.slice();

    var newNotas = []

    notasBusca.map(item=>{
        if(item.chave === payload.chave){
            newNotas.push({...payload, origem: "bipe"}) 
        }else{
            newNotas.push(item) 
        }
    })

    notasBusca = newNotas
    return {
        ...state, 
        notasBusca: newNotas
    };
};

const buscarNotasSemBanco = (state = INITIAL_STATE, action) => {
    const { payload } = action;
    let notasBusca = state.notasBusca.slice();
    let ordManual = state.ordManual.slice();
    let ordBanco = state.ordBanco.slice();
    let boolean = false;

    notasBusca.map((aux) => {
        if (aux.ar === payload.ar) {
            boolean = true;
        }
    });

    if (boolean) {
        return { ...state, notasBusca, ordManual, ordBanco };
    }

    notasBusca.unshift({
        ...payload,
        tableData: { ...payload.tableData, checked: false },
    });
    ordManual.unshift(payload);
    ordBanco.unshift(payload);

    // state.qtdBipe++;

    return {
        ...state,
        notasBusca,
        ordManual,
        ordBanco,
    };
};

const buscarNotasEditarSucesso = (state = INITIAL_STATE, action) => {
    let notasEdicaoRomaneio = state.notasEdicaoRomaneio.slice();

    notasEdicaoRomaneio.unshift(action.payload);

    return {
        ...state,
        romaneioEdicao: notasEdicaoRomaneio,
    };
};
const setRomaneioEmEdicao = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        romaneioEmEdicao: {
            ...action.payload,
        },
    };
};
const IncluirNotasRomaneio = (state = INITIAL_STATE, action) => {
    let notasRomaneioEditar = state.notasRomaneioEditar.slice();

    notasRomaneioEditar = notasRomaneioEditar.map((nota) => ({
        ...nota,
        pos_entrega: Number(nota.pos_entrega) + 1,
    }));

    let arNota = action.payload.ar_nota;
    let notasExcluidas = state.notasExcluidas;
    let duplicate =
        notasExcluidas && notasExcluidas.some((ar) => ar.arNota === arNota);
    let novasNotas = [];

    if (duplicate) {
        novasNotas = notasExcluidas.filter((ar) => ar.arNota !== arNota);
        notasRomaneioEditar.unshift({ ...action.payload, acao: "atualizar" });
    } else {
        notasRomaneioEditar.unshift(action.payload);
    }

    return {
        ...state,
        notasRomaneioEditar,
        notasExcluidas: novasNotas,
    };
};

const criarRomaneiosSucesso = (state = INITIAL_STATE, action) => {
    let notasRomaneios = action.payload.notas;

    return {
        ...state,
        agrupaDist: action.payload.agrupamentos,
        notasRomaneioCriado: notasRomaneios,
        romaneiosCriar: action.payload,
        mostrarRomaneioCriado: true,
        mostrarRomaneiosValidados: true,
    };
};

const atualizarRomaneiosSucesso = (state = INITIAL_STATE, action) => {
    let romaneioAtualizado = action.payload.romaneio;
    let notasRomaneioAtualizado = action.payload.notas;
    let agrupaDist = action.payload.agrupamentos;

    return {
        ...state,
        agrupaDist,
        notasRomaneioAtualizado: notasRomaneioAtualizado,
        romaneioAtualizado: romaneioAtualizado,
        mostrarRomaneioAtualizado: true,
        mostrarRomaneiosValidados: true,
        notasExcluidas: [],
    };
};

const setNotaEdicao = (state = INITIAL_STATE, action) => ({
    ...state,
    notaEdicao: action.payload,
});

const setNotaEdicaoRomaneio = (state = INITIAL_STATE, action) => ({
    ...state,
    NotaEdicaoRomaneio: action.payload,
});

const setAtuNotasRom = (state = INITIAL_STATE, action) => {
    const novo = action.payload;

    const notasRomaneioEditar = arrayMove(
        state.notasRomaneioEditar,
        novo.index,
        novo.pos_entrega - 1
    );

    return {
        ...state,
        notasRomaneioEditar,
    };
};

const setNotaBusca = (state = INITIAL_STATE, action) => ({
    ...state,
    notasBusca: action.payload,
});

const setNotaBuscaEdicao = (state = INITIAL_STATE, action) => ({
    ...state,
    notasRomaneioEditar: action.payload,
});

const resetRomaneio = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        notasBusca: [],
        ordManual: [],
        ordBanco: [],
    };
};

const resetRomaneioSelec = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        romaneiosSelecionados: [],
    };
};

const resetListBusRom = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        romaneiosBusca: [],
    };
};

const deletarNotaSucesso = (state = INITIAL_STATE, action) => {
    const { index } = action.payload;

    const removeIndexes = Array.isArray(index) ? index : [index];

    const newList = state.notasBusca.filter(
        (elem, index) => !removeIndexes.includes(index)
    );

    return {
        ...state,
        notasBusca: newList,
    };
};

const replaceRomaneio = (state = INITIAL_STATE, action) => {
    const { target, data } = action.payload;

    const newList = state.romaneiosBusca.map((element, index) =>
        element[target.field] === target.value ? data : element
    );

    return {
        ...state,
        romaneiosBusca: newList,
    };
};

const deletarNotaRomaneioSucesso = (state = INITIAL_STATE, action) => {
    const { index, acao } = action.payload;
    const { notasRomaneioEditar } = state;

    let arRemover = [];
    let notasExcluidas = state.notasExcluidas.slice();

    if (Array.isArray(index)) {
        index.forEach((i) => {
            arRemover.push(notasRomaneioEditar[i].ar);
            notasExcluidas.push({
                arNota: notasRomaneioEditar[i].ar,
                acao,
            });
        });
    } else {
        arRemover.push(notasRomaneioEditar[index].ar);
        notasExcluidas.push({
            arNota: notasRomaneioEditar[index].ar,
            acao,
        });
    }

    const novaLista = notasRomaneioEditar.filter(
        (nota, i) => !arRemover.includes(nota.ar)
    );

    return {
        ...state,
        notasRomaneioEditar: novaLista,
        notasExcluidas,
    };
};

const gerarRomaneiosSucesso = (state = INITIAL_STATE, action) => {
    const romaneios = action.payload;
    return {
        ...state,
        showMessageRomaneios: true,
        romaneiosMensagem: "Romaneios gerados com sucesso!",
        romaneiosGerados: romaneios,
        loadGerarRomaneios: false,
    };
};

const setLoadGerarRomaneios = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        loadGerarRomaneios: action.payload.loader,
    };
};

const criarRomaneiosSemVerificar = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        criarSemVerificar: true,
    };
};

const basesEmpresaSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        basesRom: action.payload.data,
    };
};

const setCriandoRomaneio = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        criandoRomaneio: action.payload,
    };
};

const limparRomaneios = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        romaneioEdicao: {},
        notasRomaneioCriado: [],
        romaneiosBusca: [],
        notasRomaneioEditar: [],
        romaneiosCriar: { notas: [], romaneio: {} },
        romaneioEmEdicao: {},
        agrupaDist: [],
    };
};

export default createReducer(INITIAL_STATE, {
    [Types.MOSTRAR_MENSAGEM]: acaoMostarMensagem,
    [Types.ESCONDER_MENSAGEM]: esconderMensagem,
    [Types.BUSCAR_ROMANEIOS_SUCESSO]: buscarRomaneiosSucesso,
    [Types.BUSCAR_ROMANEIOS]: buscarRomaneios,
    [Types.BUSCAR_BASES_SUCESSO]: buscarBasesSucesso,
    [Types.DELETAR_ROMANEIOS_SUCESSO]: deletarRomaneiosSucesso,
    [Types.BUSCAR_MOTORISTAS_SUCESSO]: buscarMotoristasSucesso,
    [Types.INCLUIR_NOTAS_SUCESSO]: incluirNotasSucesso,
    [Types.BUSCAR_NOTAS_SUCESSO]: buscarNotasSucesso,
    [Types.CRIAR_ROMANEIOS_SUCESSO]: criarRomaneiosSucesso,
    [Types.SET_NOTA_EDICAO]: setNotaEdicao,
    [Types.SET_NOTA_EDICAO_ROMANEIO]: setNotaEdicaoRomaneio,
    [Types.SET_NOTA_BUSCA]: setNotaBusca,
    [Types.SET_NOTA_BUSCA_EDICAO]: setNotaBuscaEdicao,
    [Types.MUDA_TOTAL_NOTAS]: mudaTotalNotas,
    [Types.MUDA_TOTAL]: mudaTotal,
    [Types.RESE_TOTAL_NOTAS]: reseTotalNotas,
    [Types.RESET_ROMANEIO]: resetRomaneio,
    [Types.DELETAR_NOTA_SUCESSO]: deletarNotaSucesso,
    [Types.DELETAR_NOTA_ROMANEIO_SUCESSO]: deletarNotaRomaneioSucesso,
    [Types.GERAR_ROMANEIOS_SUCESSO]: gerarRomaneiosSucesso,
    [Types.SET_LOAD_GERAR_ROMANEIOS]: setLoadGerarRomaneios,
    [Types.CRIAR_ROMANEIOS_SEM_VERIFICAR]: criarRomaneiosSemVerificar,
    [Types.BUSCAR_NOTAS_EDITAR_SUCESSO]: buscarNotasEditarSucesso,
    [Types.BUSCAR_NOTAS_SEM_BANCO]: buscarNotasSemBanco,
    [Types.ATUALIZAR_NOTAS_REQUEST_BANCO]: atualizarNotasRequestBanco,
    [Types.INCLUIR_NOTAS_ROMANEIO]: IncluirNotasRomaneio,
    [Types.NOTAS_EXCLUIDA_ROMANEIO]: notasExcluidaRomaneio,
    [Types.ATUALIZAR_ROMANEIOS_SUCESSO]: atualizarRomaneiosSucesso,
    [Types.SET_ATU_NOTAS_ROM]: setAtuNotasRom,
    [Types.BUSCA_ROM_VALIDAR_SUCESSO]: buscaRomValidarSucesso,
    [Types.SET_ROM_SELECIONADO]: setRomSelecionado,
    [Types.RESET_ROMANEIO_SELEC]: resetRomaneioSelec,
    [Types.LISTA_NOTAS_ROM_VALIDAR]: ListaNotasRomValidar,
    [Types.VALIDAR_ROM_APP_SUCESSO]: validarRomAppSucesso,
    [Types.SET_MOSTRAR_ROMANEIOS_VALIDADOS]: setMostrarRomaneiosValidados,
    [Types.SET_MOSTRAR_ROMANEIOS_PDF]: setMostrarRomaneiosPdf,
    [Types.RESET_LIST_BUS_ROM]: resetListBusRom,
    [Types.ORD_ARRAY_NT_BUSCA_SUCESSO]: OrdArrayNtBuscaSucesso,
    [Types.ORD_ARRAY_NT_BUSCA_MANUAL]: OrdArrayNtBuscaManual,
    [Types.NOTAS_ORD_BANCO]: notasOrdBanco,
    [Types.SET_TIPO_PDF]: setTipoPdf,
    [Types.BASES_EMPRESA_SUCESSO]: basesEmpresaSucesso,
    [Types.SET_LOAD]: setLoad,
    [Types.SET_DOC]: setDoc,
    [Types.SET_ROMANEIO_EM_EDICAO]: setRomaneioEmEdicao,
    [Types.SET_CRIANDO_ROMANEIO]: setCriandoRomaneio,
    [Types.LIMPAR_ROMANEIOS]: limparRomaneios,
    [Types.REPLACE_ROMANEIO]: replaceRomaneio,
});
